import { combineReducers } from 'redux';

import { RESET_CAPTCHA_REGISTRATION } from '../../actions/registration/constants';
import createReducer from '../../utils/createReducer';

const resetCaptcha = createReducer(0, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [RESET_CAPTCHA_REGISTRATION]: (draft, { payload }) => payload.resetCaptcha,
});

export default combineReducers({
  resetCaptcha,
});
